import { FC } from 'react';
import { Modal, Text } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

interface RiderAssistantAdvisoryModalProps {
  isOpen: boolean;
  handleContinue: () => void;
  handleClose: () => void;
}

export const RiderAssistantAdvisoryModal: FC<RiderAssistantAdvisoryModalProps> = ({
  isOpen,
  handleContinue,
  handleClose,
}) => (
  <Modal data-testid="rider-assistant-advisory-modal" open={isOpen} onClose={handleClose}>
    <Modal.Title>Rider Assistant Recommended</Modal.Title>
    <Modal.Content>
      <Text>
        {
          'This ride includes a 3-year-old rider without an accompanying rider aged 7 or older. If Rider Assistants are available in your metro, we strongly recommend requesting one for this ride, but it is not required.'
        }
      </Text>
    </Modal.Content>
    <Modal.Actions>
      <Button color="tertiary" onClick={handleClose}>
        Nevermind
      </Button>
      <Button onClick={handleContinue} color="primary" variant="contained">
        Continue Booking
      </Button>
    </Modal.Actions>
  </Modal>
);
